import { TYPES } from "@actions/tunnel-steps-actions";
import INITIAL_STATE from "./initial-state";

const tunnelStepsReducer = (state = INITIAL_STATE.tunnelSteps, action) => {
  switch (action.type) {
    case TYPES.ADD_COUPON:
      return {
        ...state,
        coupon: action.coupon,
      };
    
    case TYPES.INITIALIZE_PLAN:
      return {
        ...state,
        featuredPlan: action.featuredPlan,
      };

    case TYPES.REMOVE_COUPON:
      return {
        ...state,
        coupon: null,
      };
      
    default:
      return state;
  }
};

export default tunnelStepsReducer;
